/**
 * Confirmation chime — synthesized rising triad, ~0.5s. No audio asset, no
 * network: it can never 404 on the kiosk. Fired on a CORRECT assessment,
 * timed with the green reveal + JARVIS's spoken reaction (one system).
 */
export function playConfirmChime() {
  try {
    const ctx = new AudioContext();
    ctx.resume().catch(() => {});
    const t0 = ctx.currentTime + 0.02;
    [880, 1174.66, 1567.98].forEach((f, i) => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.type = "sine";
      o.frequency.value = f;
      const start = t0 + i * 0.09;
      g.gain.setValueAtTime(0, start);
      g.gain.linearRampToValueAtTime(0.22, start + 0.02);
      g.gain.exponentialRampToValueAtTime(0.001, start + 0.35);
      o.connect(g);
      g.connect(ctx.destination);
      o.start(start);
      o.stop(start + 0.4);
    });
    setTimeout(() => ctx.close().catch(() => {}), 900);
  } catch {
    /* audio is celebration, not function — never let it throw */
  }
}
